import { ROUTE } from "../../../routes";
import { clearAllData, getTargetParamFromURL } from "../../../configs/utils";
import { APPLICATION_STATE, TARGET_PAGES } from "../../../configs/constants";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import SharedPropsService from "../../../SharedPropsService";
import { Platform, DeviceEventEmitter } from "react-native";
export const accountDetails = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.ACCOUNT_DETAILS, {
        profileData: action.payload.value,
    });
};
export const contactDetails = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US);
};
export const faqDetails = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('FAQ_BOTTON_CLICKED', {
        source_page: 'ACCOUNT_DETAILS',
    });
    await navigate(ROUTE.FAQ);
};
export const aboutDetails = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('ABOUT_US_BUTTON_CLICKED');
    await navigate(ROUTE.ABOUTUS);
};
export const logout = async (action, _datastore, { navigateToBase, instrumentTrack, network, openNewTab }) => {
    instrumentTrack('LOGOUT_BUTTON_CLICKED', { "source": 'my_profile' });
    const user = await SharedPropsService.getUser();
    // Dispatch logout event
    if (Platform.OS === 'web') {
        const logoutEvent = new Event('logout');
        window.dispatchEvent(logoutEvent);
    }
    else {
        DeviceEventEmitter.emit('logout', `${user?.user?.userId}`);
    }
    const loginResponse = await network.post(api.logout, {}, { headers: await getAppHeader(), handleFromMF: true });
    await clearAllData();
    // @ts-ignore
    action?.payload?.setIsUserLoggedIn(null);
    if (Platform.OS === 'web') {
        action?.payload?.setShowSupportPhoneNumber(false);
    }
    await navigateToBase(ROUTE.PHONE_NUMBER);
};
export const navigateToForeclosure = async (action, _datastore, { navigate, instrumentTrack }) => {
    //@ts-ignore
    const showNewForeClosureScreen = action?.payload?.showNewForeClosureScreen;
    instrumentTrack('CLOSE_ACCOUNT_BOTTON_CLICKED');
    if (showNewForeClosureScreen) {
        await navigate(ROUTE.FORECLOSURE_NEW);
    }
    else
        navigate(ROUTE.FORECLOSURE);
};
export const goBack = async (action, _datastore, { goBack, navigate, navigateToBase, navigateWithClear }) => {
    const reFetch = false;
    const user = await SharedPropsService.getUser();
    const isApplicationStateCompleted = user?.linkedApplications[0]?.applicationState === APPLICATION_STATE.COMPLETED;
    (getTargetParamFromURL() === TARGET_PAGES.ACCOUNT ||
        isApplicationStateCompleted) ? navigate(ROUTE.DASHBOARD, {
        cacheManageLimitConfig: true,
        cacheCreditData: true,
        cachePendingCreditRequestByCreditId: true,
        // cacheUserContext: true
    })
        : navigate(ROUTE.BORROWER_LANDING_SCREEN, { reFetch });
};
export const navigateForeClosureTracking = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.TRACK_FORECLOSURE, {
        data: action?.payload.value
    });
};
export const navigateToLoanDetails = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('MY_LOAN_DETAILS_PAGE_VIEWED', {
        source_page: 'ACCOUNT_DETAILS',
    });
    await navigate(ROUTE.MY_LOAN_PROFILE);
};
export const navigateToHelpAndSupport = async (action, _datastore, { navigate, instrumentTrack }) => {
    await instrumentTrack('HELP_AND_SUPPORT_BUTTON_CLICKED', {
        source: 'lms',
    });
    await navigate(ROUTE.HELP_AND_SUPPORT_SCREEN, { userName: action?.payload?.userName });
};
